// extracted by mini-css-extract-plugin
export var avatarContainer = "_6k-0";
export var avatarTypingWave = "_6k-i";
export var gray = "_6k-f";
export var green = "_6k-c";
export var icon = "_6k-9";
export var image = "_6k-1";
export var lg = "_6k-6";
export var md = "_6k-5";
export var presenceDot = "_6k-b";
export var red = "_6k-d";
export var sm = "_6k-4";
export var status = "_6k-a";
export var typingDot = "_6k-h";
export var typingPill = "_6k-g";
export var xl = "_6k-7";
export var xs = "_6k-3";
export var xxl = "_6k-8";
export var xxs = "_6k-2";
export var yellow = "_6k-e";